import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ requiredPermission }) => {
  const { profile, loading } = useSelector((state) => state.profile);
  const isAuthenticated = !!localStorage.getItem("QC_accessToken");
  const permissions = profile?.permissions?.navigation || [];

  // Show loading state while checking authentication and profile
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={50} color="primary" />
      </Box>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If profile failed to load (invalid token), redirect to login
  if (!profile && !loading) {
    localStorage.removeItem("QC_accessToken");
    return <Navigate to="/login" replace />;
  }

  // Check if route requires specific permission
  if (requiredPermission && !permissions.includes(requiredPermission)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
